import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import { load, isProfileLoaded, resetProfileLoaded } from 'modules/HorseRacing/reducers/jockeyProfile';

import { standardAsyncConnect } from 'utils/asyncConnectWrapper';

import { canonicalLink } from 'utils/seoUtils';
import { racingProfileLink } from 'modules/HorseRacing/utils';

import SwitchBtns from 'modules/Common/components/SwitchBtns';
import ProfileHeading from 'modules/HorseRacing/components/Profiles/ProfileHeading';

require('./JockeyProfilePage.scss');

@standardAsyncConnect([
  {
    dispatch: ({ params: { jockeyId } }) => load(jockeyId),
    preventResolve: ({ state }) => isProfileLoaded(state),
    state: state => ({ profile: state.horseRacing.jockeyProfile.profile }),
    errorState: state => state.horseRacing.jockeyProfile.error,
    refreshInterval: 60000,
    preserveRefresh: true,
    reset: () => resetProfileLoaded(),
    handleError: true,
    reportStatus: true
  }
])
export default class JockeyProfilePageContainer extends Component {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    profile: PropTypes.object,
    params: PropTypes.object,
    children: PropTypes.node.isRequired
  };

  render() {
    const {
      routes,
      children,
      profile,
      profile: {
        person_details: {
          name,
          person_reference: {
            id
          } = {}
        } = {}
      } = {}
    } = this.props;

    return (
      <div className="jockey-profile">
        <MetaDataWrapper helmetProps={{...canonicalLink(routes, {jockeyId: id})}}/>
        <ProfileHeading classPrefix="jockey" type="JOCKEY" {...{id, name}}/>
        <SwitchBtns buttons={[
          {href: racingProfileLink('jockey', id), isIndex: true, text: "All Results"},
          {href: `${racingProfileLink('jockey', id)}/future-entries`, text: "Future Entries"}
        ]}/>
        {children && React.cloneElement(children, { profile })}
      </div>
    );
  }

  renderError() {
    return (
      <div className="jockey-profile">
        <h1>Jockey not found</h1>
        <div className="jockey-profile-not-found">The jockey you were looking for could not be found</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/Profiles/JockeyProfilePageContainer.js